module.exports = __webpack_public_path__ + "img/mmbear.5730e68b.png";